export var Emotions;
(function (Emotions) {
    Emotions["POSITIVE"] = "POSITIVE";
    Emotions["NEGATIVE"] = "NEGATIVE";
    Emotions["NEUTRAL"] = "NEUTRAL";
    Emotions["INDETERMINATE"] = "INDETERMINATE";
})(Emotions || (Emotions = {}));
